/* eslint-disable react/prop-types */
import { HeaderSideNavItems as CarbonHeaderSideNavItems } from '@carbon/react';

export const HeaderSideNavItems = ({ children, ...props }) => (
  <CarbonHeaderSideNavItems {...props}>{children}</CarbonHeaderSideNavItems>
);
